import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint, MustPreloadLoadableNames } from '@confluence/loadable';
import type { ViewPageProps } from '../src/ViewPage.tsx';

export const ViewPageLoader: LoadableType<ViewPageProps> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ViewPage" */ '../src/ViewPage.tsx')).ViewPage,
	_mustPreloadWhenRenderingSPA: [MustPreloadLoadableNames.ViewPageRouteComponentLoader],
});
